import { AuthLayout } from '@shared/layouts';
import PageContainer from '@shared/components/container/PageContainer';
import { SignInForm } from '@features/Auth';
import { useSignIn } from '@features/Auth/SignIn/hooks/useSignIn';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SuperAdminUnauthenticatedPath } from '@shared/constants/routes.constants';
import { useStyles } from '../styles';
import { isDevEnvironment } from '@shared/utils/env';

export const SignInPage = () => {
  const { onSubmit, control, setValue, errorMsg, formState } = useSignIn();
  const navigate = useNavigate();
  const styles = useStyles();

  return (
    <PageContainer title="Sign In" useProductSuffix>
      <AuthLayout className={styles.classes.layout}>
        <div className={styles.classes.root}>
          {isDevEnvironment && (
            <Button
              className={styles.classes.switchButton}
              variant="contained"
              disableElevation
              onClick={() => navigate(SuperAdminUnauthenticatedPath.SIGN_IN)}>
              Sign in as root admin
            </Button>
          )}
          <SignInForm
            onSubmit={onSubmit}
            control={control}
            setValue={setValue}
            errorMsg={errorMsg}
            formState={formState}
          />
        </div>
      </AuthLayout>
    </PageContainer>
  );
};
